import { render, staticRenderFns } from "./bubget-price.vue?vue&type=template&id=d1f04c4c"
import script from "./bubget-price.vue?vue&type=script&lang=ts"
export * from "./bubget-price.vue?vue&type=script&lang=ts"
import style0 from "./bubget-price.vue?vue&type=style&index=0&id=d1f04c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports